// A report URL that is not one of the user's own orders (403) or leads to no report (404). The report page answers
// it itself (SC-QA-17), so these statuses must not reach the axios interceptor's error-page redirect
const UNAVAILABLE_STATUSES = [403, 404];

export const allowUnavailable = {
    validateStatus: code => (code >= 200 && code < 300) || UNAVAILABLE_STATUSES.includes(code),
};

export const isUnavailableStatus = status => UNAVAILABLE_STATUSES.includes(status);

// GET /jobs/:uuid answers a job that is not the user's, or no job at all, with 400 ("not found in the database"),
// so for that request 400 means unavailable too. Only there: a 400 elsewhere stays an error
const JOB_UNAVAILABLE_STATUSES = [400, ...UNAVAILABLE_STATUSES];

export const allowJobUnavailable = {
    validateStatus: code => (code >= 200 && code < 300) || JOB_UNAVAILABLE_STATUSES.includes(code),
};

export const isJobUnavailableStatus = status => JOB_UNAVAILABLE_STATUSES.includes(status);

export const reportUnavailableError = () => Object.assign(new Error('Report unavailable'), { reportUnavailable: true });

export const isReportUnavailable = error => !!(error && error.reportUnavailable);

// The page of one of the user's own orders, by its job type
export const ownReportPath = record => {
    if (record.type === 'combined') return `/combined-report/${record.vin}/${record.uuid}`;
    if (record.type === 'internal') return `/internal-report/${record.vin}`;
    return `/report/${record.uuid}`;
};

// The user's latest order for this VIN among their orders, or null
export const latestOrderForVin = (records, vin) => {
    const wanted = String(vin || '').toLowerCase();
    const matches = (records || []).filter(record => String(record.vin || '').toLowerCase() === wanted);
    matches.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    return matches[0] || null;
};
